<template>
  <div class="pb-3 mb-3 border-b-2 border-t-0 border-r-0 border-l-0 border-dashed border-gray-400" v-if="patientInfo">
    <div class="row mb-2"></div>
    <div class="row mb-2">
      <div class="col-lg-6">
        <label class="font-bold mr-1">PID:</label>
        <!-- TODO: update HID data -->
        <span>{{ patientInfo.pid }}</span>
      </div>
      <!-- <div class="col-lg-6">
        <label class="font-bold mr-1">Họ và tên:</label>
        <span>{{ patientInfo.name }}</span>
      </div>-->
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-6">
            <label class="font-bold mr-1">{{ $t("lbl_sex") }}:</label>
            <span>{{ mdtUtils.getGender(patientInfo.gender) }}</span>
          </div>
          <div class="col-lg-6">
            <label class="font-bold mr-1">{{ $t("lbl_age") }}:</label>
            <span>
              {{ patientInfo.birthday && mdtUtils.getAges(new Date(patientInfo.birthday)) }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>
      <label class="font-bold mr-1">Địa chỉ:</label>
      <span>{{ getAddress(patientInfo) }}</span>
    </div>-->
  </div>
</template>

<script>
import appUtils from '@/utils/appUtils'
import mdtUtils from '@/utils/mdtUtils'
import { mixinGetPersonInfo } from '@/utils/mixinGetPersonInfo'

export default {
  name: 'RISHeader',
  mixins: [mixinGetPersonInfo],
  props: {
    emrData: Object
  },
  data () {
    return {
      appUtils,
      mdtUtils,
      patientId: this.emrData?.id ? this.emrData?.patient_id : Number(this.$route.params?.id) || null,
      patientInfo: null
    }
  },
  async mounted () {
    await this.getPatientData()
  },
  watch: {
    emrData: {
      async handler (data) {
        if (!data?.id) {
          return
        }
        this.patientId = data.patient_id
        await this.getPatientData(this.emrData?.patient_id)
      },
      deep: true
    },
    '$route.params': {
      async handler (data) {
        const { id } = data
        if (!Number.isNaN(Number(id))) {
          if (this.emrData?.id) {
            await this.getPatientData(this.emrData?.patient_id)
          } else {
            await this.getPatientData(Number(id))
          }
        }
      },
      deep: true
    }
  },
  methods: {
    async getPatientData (patientId) {
      const id = patientId || this.patientId

      if (!id) return

      try {
        const res = await this.$rf.getRequest('DoctorRequest').getPatientConnectRequest(id)

        if (!res?.data) return
        this.patientInfo = res.data
        this.$emit('setPatientInfo', res.data)
      } catch (error) {
        console.log(error)
      } finally {
        this.$emit('setIsLoading', false)
      }
    }
  }
}
</script>
